export const coverCropsGraphTheme = {
    color: ['#744B1B', '#2D7059', '#84C19F', '#C5DDD0', '#FDD980'],
};
